import styled from 'styled-components';

import { JourneyParticipant as BaseParticipantInfo } from '@/features/journey/admin/atoms/JourneyParticipant';

const RootStyled = styled(BaseParticipantInfo)`
  padding: 0;
`;

export const LearnerInfo = ({
  row: { email, profileImage, name },
}: {
  row: { email: string; profileImage?: string; name: string };
}): JSX.Element => {
  return <RootStyled name={name} email={email} profileImage={profileImage} />;
};
